<template>
  <div>
    <q-btn
      outline
      color="primary"
      icon="mdi-pencil"
      :disable="disable"
      class="batch-btn export-btn"
      @click="init()"
      >一括入力</q-btn
    >
    <q-dialog v-model="dialogFlg" class="batchinput-button" persistent>
      <q-card style="width: 700px; max-width: inherit">
        <q-toolbar style="padding: 0">
          <q-toolbar-title>
            <span class="text-weight-bold" style="font-size: 22px; color: var(--q-primary)"
              >一括入力</span
            >
          </q-toolbar-title>
        </q-toolbar>
        <q-card-section>
          <div class="row q-gutter-sm">
            <div v-if="capacityFlg" class="col-3">
              <label> 希望容量 </label>
              <q-input
                v-model="desiredCapacity"
                clearable
                class="input-area left-input"
                outlined
                dense
                maxlength="30"
              />
            </div>
            <div class="col-3">
              <label> 数量 </label>
              <q-input
                v-model="desiredQuantity"
                outlined
                dense
                mask="##"
                maxlength="2"
                input-class="text-right"
                class="input-area"
                style="width: 100px"
              />
            </div>
            <div class="col-12">
              <label> コメント </label>
              <q-input
                v-model="comment"
                clearable
                outlined
                dense
                counter
                maxlength="200"
                type="textarea"
                class="input-area left-input"
                autogrow
              />
            </div>
          </div>
        </q-card-section>
        <q-card-actions align="center" class="text-primary">
          <q-btn color="primary" label="確定" @click="batchInput" />
          <q-btn
            label="キャンセル"
            outline
            style="color: var(--q-delete); margin-left: 12px"
            @click="dialogFlg = false"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';

interface Props {
  // 容量表示フラグ
  capacityFlg: boolean;
  // 非活性フラグ
  disable: boolean;
}
defineProps<Props>();

// コメント一括入力 interface
interface AllInputComent {
  desiredCapacity: string;
  desiredQuantity: string;
  comment: string;
}

// ダイアログ表示フラグ
const dialogFlg = ref(false);
// 希望容量
const desiredCapacity = ref('');
// 希望数量
const desiredQuantity = ref('0');
// コメント
const comment = ref('');

// 初期値設定
const init = () => {
  desiredCapacity.value = '';
  desiredQuantity.value = '1';
  comment.value = '';
  dialogFlg.value = true;
};

const emit = defineEmits<{
  (event: 'batchInput', inputs: AllInputComent): void;
}>();

// 一括入力
const batchInput = () => {
  const inputs = {
    desiredCapacity: desiredCapacity.value,
    desiredQuantity: desiredQuantity.value,
    comment: comment.value,
  };
  dialogFlg.value = false;
  emit('batchInput', inputs);
};
</script>
<style scoped>
.batchinput-button label {
  font-size: 0.8rem;
}

.batchinput-button .q-card {
  min-width: 400px;
  padding: 15px 30px;
}

.batchinput-button h6 {
  margin: 0 0 5px;
  letter-spacing: 3px;
  font-size: 1rem;
}

.batchinput-button .q-btn {
  width: 120px;
}

.batch-btn.q-btn:disabled,
.batch-btn.q-btn.disabled {
  background-color: var(--q-opacityDisable) !important;
  border-color: var(--q-opacityDisable) !important;
  color: #fff !important;
}
</style>
<style>
.batchinput-button .q-textarea.q-field--dense.input-area.left-input .q-field__native,
.batchinput-button .q-textarea.q-field--dense .q-field__control {
  min-height: 70px;
}

.batchinput-button .q-card__section {
  padding: 0;
}

.batchinput-button .q-card__actions {
  margin-top: 20px;
}

.batchinput-button .input-area .q-field__control {
  align-items: center;
}
</style>
